import React from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import {serverRootUrl} from "../../config";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            overflowX: 'scroll',
            height: 84,
            marginTop: 1,
        },
        inner: {
        },
        thumbItem: {
            marginRight: 1,
            width: 100,
            maxWidth: 100,
            float: 'left',
            position: 'relative',
            height: 75,
            maxHeight: 75,
            overflow: 'hidden',
            '&::after': {
                boxSizing: 'inherit',
                content: '""',
                position: 'absolute',
                borderBottom: '3px solid transparent',
                width: '0',
                height: 2,
                bottom: 0,
                left: 0,
            },
            '&:hover': {
                '&::after': {
                    width: '100%',
                    height: 2,
                    borderBottomColor: '#3849a4',
                    wtransition: 'width 0.15s ease-out, height 0.15s ease-out 0.15s'
                },
            }
        },
        image: {
            cursor: 'pointer',

        }
    }});

export default function MobileThumbs(props) {

    const classes = useStyles();
    const header = props.header;
    const item = props.item;

    const rootRef = React.useRef();

    const onClick = (index) => {
        props.onClick(index);
    };

    const onError = (e) => {
        const newSrc = e.target.src.split('_thumb').join('');
        if (newSrc !== e.target.src) {
            e.target.src = newSrc;
        }
    };

    let images = item.images;

    return (
        <div className={classes.root} style={{
            maxWidth: props.wrapperWidth - 1

        }}>
            <div className={classes.inner} style={{
                width: item.images ? item.images.length * 101 : 0
            }}>
            {images && images.map((im, index) => {
                const url = im.image.split('.').join('_thumb.')+'?1';
                return <div className={classes.thumbItem}><img className={classes.image}
                            width="100%"
                            alt={im.description ? im.description : header}
                            src={serverRootUrl + '/' + url}
                            onClick={() => onClick(index)}
                            onError={onError}
                /></div>;
            })}
        </div></div>
    );
}
